<template>
  <v-col lg="3" md="3" sm="3" cols="12" class="align-center">
    <v-container class="custom-color" @click="$emit('isClick', color_type)">
      <v-row class="pr-4 text-center">
        <v-col cols="4" class="ma-auto">
          <v-btn :color="color" elevation="3" fab></v-btn>
        </v-col>

        <v-col cols="4" class="ma-auto">
          <span class="text-md-body-1 theme-color">{{ color_title }}</span>
        </v-col>

        <v-col cols="4" class="ma-auto">
          <span class="text-md-body-1 theme-color">{{ color }}</span>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
export default {
  name: "colorButton",
  props: {
    color_title: String,
    color_type: String,
    color: String,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.custom-color {
  border: 1px solid #607d8b;
  border-radius: 5px;
  cursor: pointer;
  width: 100%;
}

.theme-color {
  color: #607d8b;
}
</style>
